import * as React from 'react';
// mui components
import Dialog from '@mui/material/Dialog';
import { Avatar, Divider, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
// icons
import CrossIcon from 'assets/icons/buttons/cross.svg';
// styles
import { audienceListStyles } from './styles';
// utils
import { getImageBySize } from 'utils/helpers';
// types
import { IUserMe } from 'redux-store/types';
import DefaultAvatar from 'components/default-avatar';
// custom hooks

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <CrossIcon
          aria-label="close"
          onClick={onClose}
          style={{
            position: 'absolute',
            right: 21,
            top: 21,
            cursor: 'pointer',
          }}
        >
          <CloseIcon />
        </CrossIcon>
      ) : null}
    </DialogTitle>
  );
}

type AudienceProps = {
  openAudienceModal: boolean;
  closeAudienceModal: () => void;
  postAudienceMembers: {
    profileId: number;
    firstName: string;
    lastName: string;
    roleName: string;
    avatar: string;
  }[];
  userMe: IUserMe;
};

const PostAudienceListModal: React.FC<AudienceProps> = ({
  openAudienceModal,
  closeAudienceModal,
  postAudienceMembers,
  userMe,
}) => {
  return (
    <div>
      <BootstrapDialog
        onClose={closeAudienceModal}
        aria-labelledby="customized-dialog-title"
        open={openAudienceModal}
        PaperProps={{
          sx: {
            width: '430px',
            borderRadius: '12px',
            paddingBottom: '10px',
          },
        }}
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={closeAudienceModal}>
          <Typography sx={audienceListStyles.likesText}>Post Visibility</Typography>
          <Typography sx={audienceListStyles.membersText}>
            Here is a list of users who can see this post in their feed.
          </Typography>
        </BootstrapDialogTitle>
        <Divider sx={audienceListStyles.divider} />
        <Grid sx={audienceListStyles.scrollContainer}>
          {!postAudienceMembers.length ? (
            <Grid sx={audienceListStyles.membersContainer}>
              {userMe.avatar ? (
                <Avatar
                  alt="avatar"
                  sx={audienceListStyles.userAvatar}
                  src={getImageBySize(userMe.avatar, 36, 36)}
                  variant="square"
                />
              ) : (
                <DefaultAvatar
                  initials={`${userMe.firstName[0]}${userMe.lastName[0]}`}
                  variant="square"
                  alt="avatar"
                  sx={{ borderRadius: '4px', width: '36px', height: '36px' }}
                />
              )}
              <Typography
                sx={audienceListStyles.userName}
              >{`${userMe?.firstName} ${userMe?.lastName}`}</Typography>
            </Grid>
          ) : (
            postAudienceMembers?.map((user) => {
              return (
                <Grid sx={audienceListStyles.membersContainer} key={user.profileId}>
                  {user.avatar ? (
                    <Avatar
                      alt="avatar"
                      sx={audienceListStyles.userAvatar}
                      src={getImageBySize(user.avatar, 36, 36)}
                      variant="square"
                    />
                  ) : (
                    <DefaultAvatar
                      initials={
                        user?.firstName && user?.lastName
                          ? `${user.firstName[0]}${user.lastName[0]}`
                          : ''
                      }
                      variant="square"
                      alt="avatar"
                      sx={{ borderRadius: '4px', width: '36px', height: '36px' }}
                    />
                  )}
                  <Typography
                    sx={audienceListStyles.userName}
                  >{`${user.firstName} ${user.lastName}`}</Typography>
                </Grid>
              );
            })
          )}
        </Grid>
      </BootstrapDialog>
    </div>
  );
};

export default PostAudienceListModal;
